package react.gtm

/**
 * See https://github.com/alinemorelli/react-gtm/blob/master/src/TagManager.js
 *
 * @author Franco Sabadini (franco@supergenerous.com)
 */
public data class TagManagerArgs(
    val gtmId: String
)